import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "space-y-1.5" }
const _hoisted_3 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_4 = { class: "min-w-0 truncate font-semibold text-catering-ink-900" }
const _hoisted_5 = { class: "mt-1 space-y-0.5 text-xs" }
const _hoisted_6 = { class: "flex justify-between gap-3" }
const _hoisted_7 = { class: "text-catering-ink-700" }
const _hoisted_8 = { class: "flex justify-between gap-3" }
const _hoisted_9 = { class: "text-catering-ink-700" }
const _hoisted_10 = {
  key: 0,
  class: "flex justify-between gap-3"
}
const _hoisted_11 = { class: "mt-2 space-y-0.5 text-xs" }
const _hoisted_12 = { class: "flex justify-between gap-3" }
const _hoisted_13 = { class: "text-catering-ink-700" }
const _hoisted_14 = { class: "flex justify-between gap-3" }
const _hoisted_15 = { class: "text-catering-ink-700" }
const _hoisted_16 = { class: "flex justify-between gap-3" }

import { computed } from 'vue'

export default {
  __name: 'BotStoreProfile',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const props = __props
const merchant = computed(() => props.block.merchant || {})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Store setup", -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.stores || [], (s, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-100 px-2.5 py-2"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(s.store_name), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["shrink-0 rounded px-1.5 py-0.5 text-[11px] font-medium", 
              s.status === 'live'
                ? 'bg-catering-herb-100 text-catering-herb-600'
                : 'bg-catering-cream-300 text-catering-ink-600'
            ])
            }, _toDisplayString(s.status), 3)
          ]),
          _createElementVNode("dl", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Tax", -1)),
              _createElementVNode("dd", _hoisted_7, _toDisplayString(s.tax_structure), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Tipping", -1)),
              _createElementVNode("dd", _hoisted_9, _toDisplayString(s.allow_tipping ? 'On' : 'Off'), 1)
            ]),
            (s.locked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("dt", { class: "text-catering-ink-500" }, "Access", -1),
                  _createElementVNode("dd", { class: "text-catering-berry-600" }, "Locked", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("dl", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Business", -1)),
        _createElementVNode("dd", _hoisted_13, _toDisplayString(merchant.value.business_name), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Time zone", -1)),
        _createElementVNode("dd", _hoisted_15, _toDisplayString(merchant.value.time_zone), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Payments", -1)),
        _createElementVNode("dd", {
          class: _normalizeClass(merchant.value.stripe_connected ? 'text-catering-herb-600' : 'text-catering-berry-600')
        }, _toDisplayString(merchant.value.stripe_connected ? 'Stripe connected' : 'Stripe not connected'), 3)
      ])
    ])
  ]))
}
}

}